import store from '@/store/index'

export function hasPermission(per) {
  const myPermissions = store.getters.per
  return myPermissions.indexOf(per) > -1
}
